import { environment } from 'src/environments/environment';

// A store-wide provider (Google, Mapbox, a paid OSM host) can be set with `mapTileUrl` / `mapAttribution`
// in the environment file; without one the public OpenStreetMap tiles are used.
export const DEFAULT_MAP_TILE_URL = 'https://tile.openstreetmap.org/{z}/{x}/{y}.png';
export const DEFAULT_MAP_ATTRIBUTION =
  '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a> contributors';

export interface MapConfig {
  tileUrl: string;
  attribution: string;
}

/** Tile settings come from the environment file, with OpenStreetMap as the default. */
export function mapConfig(): MapConfig {
  const env = environment as { mapTileUrl?: string; mapAttribution?: string };
  return {
    tileUrl: env.mapTileUrl || DEFAULT_MAP_TILE_URL,
    attribution: env.mapAttribution || DEFAULT_MAP_ATTRIBUTION,
  };
}
